(function () {
  'use strict';

  var prefetched = new Set();
  var hoverTimer = null;
  var maximumPrefetches = 4;

  function eligibleUrl(link) {
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return null;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return null;
    }

    if (url.origin !== window.location.origin || url.href === window.location.href) return null;
    if (!/^https?:$/.test(url.protocol)) return null;
    if (/\/(cart|checkout|account)(\/|$)/.test(url.pathname)) return null;

    url.hash = '';
    return url.href;
  }

  function prefetch(link) {
    if (prefetched.size >= maximumPrefetches) return;

    var href = eligibleUrl(link);
    if (!href || prefetched.has(href)) return;

    var hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.as = 'document';
    hint.href = href;
    document.head.appendChild(hint);
    prefetched.add(href);
  }

  document.addEventListener('pointerover', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    window.clearTimeout(hoverTimer);
    hoverTimer = window.setTimeout(function () { prefetch(link); }, 80);
  }, { passive: true });

  document.addEventListener('pointerout', function () {
    window.clearTimeout(hoverTimer);
  }, { passive: true });

  document.addEventListener('touchstart', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    prefetch(link);
  }, { passive: true });
})();
